import React from "react";
import {
  LogoWrapper,
  Image,
  BoxWrapper,
  Box,
  PlusWrapper,
  PlusIcon,
  IconWrapper,
  Icon,
  Bar,
  Download,
  ReloadIcon,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PRIVATE_ROUTE } from "@router/route.constants";
import { useDispatch, useSelector } from "react-redux";
import { setOpenLoginAlert, saveUser } from "@redux/auth/authSlice";
import { getFormattedNumber } from "@utils";
import { PUBLIC_ROUTE } from "@router/route.constants";
import Lottie from "react-lottie";
import { BalanceLoading } from "@assets";
import { useState } from "react";
import { api } from "@api";
import { localStorage } from '@utils';

const Appbar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { main_balance, bonus, is_in_game, can_exit_check } = useSelector((state) => state?.auth?.user);
  const isLoggedIn = useSelector((state) => state.auth.token);
  const [loading, setLoading] = useState(false);

  const goToWallet = () => {
    if (!isLoggedIn) {
      dispatch(setOpenLoginAlert(true));
      return;
    }
    navigate(`/${PRIVATE_ROUTE.WALLET}`);
  };

  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  }

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  }

  const checkExit = (e) => {
    e.preventDefault();
    if (!loading) {
      setLoading(true);
      api
        .checkExit()
        .then(({ user }) => {
          // save user to redux
          dispatch(saveUser(user));
          // save user to localstorage
          localStorage.setUser(user);

        })
        .catch(() => { });
    }
  }

  const Logo = () => (
    <LogoWrapper>
      <Image />
    </LogoWrapper>
  );

  const Balance = () => (
    <BoxWrapper>
      <Box>
        <div id="blc-text" onClick={goToWallet}>
          {is_in_game
            ? <Lottie
              options={{
                animationData: BalanceLoading,
              }}
              width={32}
              height={12}
            />
            : `${getFormattedNumber(main_balance + bonus)} Ks`
          }
        </div>
        <PlusWrapper transparent={can_exit_check ? 'true' : 'false'}>
          {can_exit_check
            ? <ReloadIcon onClick={checkExit} />
            : <PlusIcon onClick={goToWallet} />
          }
        </PlusWrapper>
      </Box>
    </BoxWrapper>
  );

  const Icons = () => (
    <IconWrapper>
      <Download onClick={goToDownload} />
      <Icon onClick={goToSearch} />
    </IconWrapper>
  );

  return (
    <Bar>
      <Balance />
      <Logo />
      <Icons />
    </Bar>
  );
};

export default Appbar;
